import { Pipe, PipeTransform } from '@angular/core';
//import { countryBmkFormatter, countryNoBmkFormatter } from '@utils/charts/chart-tooltip';
//import type { TooltipFormatterContextObject } from 'highcharts';
import { worldMap } from './geo-jsons';
import { CountryData } from './table-to-country.pipe';

const mapOuterVerticalPadding: number = 48;
const mapInnerPadding: number = 10;
const mapLegendHeight: number = 24;

//const noBmkFormatter: (this: TooltipFormatterContextObject) => string = countryNoBmkFormatter;
//const bmkFormatter: (this: TooltipFormatterContextObject) => string = countryBmkFormatter;

@Pipe({
  name: 'countryChartOptions',
  standalone: true,
})
export class CountryChartOptionsPipe implements PipeTransform {
  transform(data: CountryData | undefined): Highcharts.Options | undefined {
    if (!data) {
      return undefined;
    }

    //const formatter: Highcharts.TooltipFormatterCallbackFunction = data.bmk ? bmkFormatter : noBmkFormatter;
    return <Highcharts.Options>{
      chart: {
        spacing: [0, 0, 0, 0],
        margin: [0, 0, 0, 0],
        animation: false,
        height: 566,
        map: worldMap,
      },

      title: undefined,

      mapNavigation: {
        enabled: true,
        enableButtons: false,
        buttonOptions: {
          verticalAlign: 'bottom',
        },
        enableMouseWheelZoom: false
      },

      mapView: {
        padding: [
          mapInnerPadding + mapOuterVerticalPadding,
          mapInnerPadding,
          mapInnerPadding + mapOuterVerticalPadding + mapLegendHeight,
          mapInnerPadding,
        ],
      },

      legend: {
        layout: 'horizontal',
        x: 100,
        y: -48,
        align: 'left',
        symbolRadius: 0,
        verticalAlign: 'bottom',
        itemStyle: {
          fontSize: '14px',
        },
      },

      colorAxis: {
        dataClasses: [
          {
            from: 0,
            to: 10,
            name: '< 10',
            color: '#c8d5e7',
          },
          {
            from: 10,
            to: 50,
            name: '≥ 10 bis < 50',
            color: '#99abd0',
          },
          {
            from: 50,
            to: 100,
            name: '≥ 50',
            color: '#00358e',
          },
        ],
      },

      series: [
        {
          type: 'map',
          data: data.data,
          custom: {
            labels: data.labels,
            bmk: data.bmk,
          },
        },
      ],

      tooltip: {
        //formatter: formatter,
      },

      credits: {
        enabled: false,
      },
    };
  }
}
